import { Reducer } from 'redux';
import * as actionTypes from './actionTypes';
import * as utils from './utils';
import {
  PlansState,
  PlansActionTypes,
  PlansAddActionType,
  PlansUpdateActionType,
  PlansRemoveActionType,
} from './types';

/* State Shape
{
  [planId]: plan,
  ...
}
*/

const initialState: PlansState = {};

const reducer: Reducer<
PlansState,
PlansActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD: return utils.add(state, action as PlansAddActionType);
    case actionTypes.UPDATE: return utils.update(state, action as PlansUpdateActionType);
    case actionTypes.REMOVE: return utils.remove(state, action as PlansRemoveActionType);
    case actionTypes.CLEAR: return {};
    default: return state;
  }
};

export default reducer;
